export { default } from './Login';
export { default as reducer } from './Login.ducks';
export { default as sagas } from './Login.sagas';

import * as actions from './Login.ducks';
export { actions };
